<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{this.title}}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal overflow-hidden">

                    <v-row no-gutters>
                        <v-col cols="12" sm="12" md="3">
                            <label class="f-label">{{$t("Год")}}</label>
                        </v-col>
                        <v-col cols="12" sm="12" md="9">
                            <v-select
                                return-object
                                :items="meetingYears"
                                v-model="yearModel"
                                hide-details
                                required
                                :rules="requiredRule.concat(integerNotNull)"
                                outlined
                                dense
                                :menu-props="{ bottom: true, offsetY: true }"
                                @click:clear="yearModel = null"
                                append-icon="fas fa-chevron-down"
                            ></v-select>
                        </v-col>
                    </v-row>   

                    <v-row no-gutters>

                        <v-col cols="12" sm="12" md="3">
                            <label class="f-label">{{ $t("Месяц") }}</label>
                        </v-col>
                        
                        <v-col cols="12" sm="12" md="9">
                            <v-select
                                v-model="monthModel"
                                :items="meetingMonths"
                                :item-text="item => $t(item.Value)"
                                item-value="id"
                                hide-details
                                required
                                :rules="requiredRule.concat(integerNotNull)"
                                outlined
                                dense
                                append-icon="fas fa-chevron-down"
                                :menu-props="{ bottom: true, offsetY: true }"
                            >
                            </v-select>
                        </v-col>

                    </v-row>
 
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan" 
                        text
                        depressed 
                        @click="generate_report" 
                        v-if="yearModel && monthModel"
                    >
                        {{$t("сформировать_отчет")}}
                    </v-btn>

                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { mapGetters } from 'vuex';

export default {
    name: "ReportYearMonthDlg",
    data () {
        return {
            title: i18n.t("Параметры_отчета"),
            visible: false,
            resolve: null,
            reject: null,
            options: null,
            yearModel: null,
            monthModel: null
        }
    },
    computed:{
        ...mapGetters('planner', { meetingMonths: 'getMeetingMonths', meetingYears: 'getMeetingYears'}),
        ...mapGetters({ requiredRule: 'getRequiredRule', integerNotNull: 'getIntegerNotNullRule' }),
    },
    methods: {
        async open(options = {})
        {
            this.reset();

            this.visible = true;
            this.search = null,
            this.options = Object.assign({
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            }, options);

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.visible = false;
            if (!this.reject) {  
                new Promise((reject) => {
                    this.reject = reject;
                });
            }
            this.reject({
                isCancelled: true,
                message: "Действие_отменено"
            });
        },
        generate_report() {
            this.visible = false;
            this.resolve({ Year: this.yearModel, Month: this.monthModel });
        },
        reset() {
            this.monthModel = null;
            this.yearModel = null;
        }
    }
}
</script>